module.exports = __webpack_public_path__ + "static/media/video_play_icon.9aeffa00.svg";